<div class="login-form shadow-5 position-relative">
  <div *ngIf="gettingUserDetails" class="position-absolute top-50 start-50 translate-middle vstack"
       style="z-index:1000;">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="loading-text">
      Loading
    </div>
  </div>
  <div class="row justify-content-center form">
    <h2 class="login-form-title">User Login</h2>
    <div *ngIf="status=='tokenExpired'" class="alert alert-warning d-flex align-items-center"
         style="height: 30px;" role="alert">
      <i class="bi bi-exclamation-circle-fill"></i>&nbsp;&nbsp;&nbsp;Token expired
    </div>
    <form class="row g-3" [formGroup]="form" (ngSubmit)="onClickSubmit()" novalidate>
      <div class="col-md-12 text-start">
        <label for="username" class="form-label">Username</label>
        <input type="text" class="form-control" id="username" formControlName="username"
               [ngClass]="{ 'is-invalid': submitted && formControl['username'].errors }">
        <div *ngIf="submitted && formControl['username'].errors" class="invalid-feedback">
          <div *ngIf="formControl['username'].errors['required']">
            Username is required
          </div>
        </div>
      </div>
      <div class="col-md-12 text-start">
        <label for="password" class="form-label">Password</label>
        <input type="password" class="form-control" id="password" formControlName="password"
               [ngClass]="{ 'is-invalid': submitted && formControl['password'].errors }">
        <div *ngIf="submitted && formControl['password'].errors" class="invalid-feedback">
          <div *ngIf="formControl['password'].errors['required']">
            Password is required
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="form-check d-flex">
          <input mdbCheckbox class="form-check-input mb-3" type="checkbox" value="" id="flexCheckDefault"/>
          <label class="form-check-label" for="flexCheckDefault">
            Remember me
          </label>
        </div>

      </div>
      <button type="button" class="btn btn-primary" type="submit">
        <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p *ngIf="!loading">
          Login
        </p>
      </button>

    </form>
  </div>
</div>
